import React from 'react'

const SquareMeters = ({ area }) => (
  <>
    {area} m<sup>2</sup>
  </>
)

export default SquareMeters
